"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.configInfo = configInfo;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function configInfo(pram) {
  return (0, _request.default)({
    url: '/supplier/system/config/info',
    method: 'GET',
    params: {
      formId: pram.id
    }
  });
}